import React from 'react'
import styled from 'styled-components'

import Tier from 'components/vype-plus/Tier'
import GridRow from 'components/grid/GridRow'
import GridItem from 'components/grid/GridItem'

import Dollar from 'icons/dollar.svg'
import Mail from 'icons/mail.svg'
import Calendar from 'icons/calendar.svg'

const Container = styled.div`
  position: relative;
  max-width: 1120px;
  margin-left: auto;
  margin-right: auto;
`

const TierComparison = () => (
  <Container>
    <GridRow>
      <GridItem xs="1-1" md="1-3" equalHeight>
        <Tier
          name="Silver"
          theme="#fff"
          benefits={['15% discount code every month', 'Free shipping on all orders', 'Birthday gift']}
          requirements={[
            {
              icon: <Dollar />,
              text: 'Lifetime spend $100 or more'
            },
            {
              icon: <Mail />,
              text: 'Subscribe to newsletter'
            },
            {
              icon: <Calendar />,
              text: 'Minimum of one order per month'
            }
          ]}
        />
      </GridItem>
      <GridItem xs="1-1" md="1-3" equalHeight>
        <Tier
          name="Gold"
          theme="#FFEAA0"
          benefits={[
            '20% discount code every month',
            'Free shipping on all orders',
            'Birthday gift',
            'Early access to new flavours'
          ]}
          requirements={[
            {
              icon: <Dollar />,
              text: 'Lifetime spend $250 or more'
            },
            {
              icon: <Mail />,
              text: 'Subscribe to newsletter'
            },
            {
              icon: <Calendar />,
              text: 'Minimum of one order per month'
            }
          ]}
          hasDesktopDivider
          hasDividerLine
        />
      </GridItem>
      <GridItem xs="1-1" md="1-3" equalHeight>
        <Tier
          name="Platinum"
          theme="#CCC0C0"
          benefits={[
            '2 x 25% discount codes every month',
            'Free express shipping on all orders',
            'Birthday gift',
            'Early access to new flavours and devices',
            'Additional 5% discount on subscription orders'
          ]}
          requirements={[
            {
              icon: <Dollar />,
              text: 'Lifetime spend $400 or more'
            },
            {
              icon: <Mail />,
              text: 'Subscribe to newsletter'
            },
            {
              icon: <Calendar />,
              text: 'Minimum of one order per month'
            }
          ]}
          hasDividerLine
        />
      </GridItem>
    </GridRow>
  </Container>
)

export default TierComparison
